/**
 * Created by iamso on 24.09.2021
 */

const MicrosoftPayments = function () {
    Payments.call(this, connector.MICROSOFT);
};

MicrosoftPayments.prototype = Object.create(Payments.prototype);
MicrosoftPayments.prototype.constructor = MicrosoftPayments;

MicrosoftPayments.prototype._connect = function (callback) {
    if (connector.platform.oneOf(connector.MICROSOFT)) {
        callback(connector.STATUS_CONNECTED);
        return;
    }

    connector.platform.callNative("store.connect", {}, () => {
        this.connectedTime = Date.now();

        console.log("MicrosoftPayments._connect");
        callback(connector.STATUS_CONNECTED);
    });
};

MicrosoftPayments.prototype.getProductId = function (config) {
    return config.id[connector.info.source];
};

MicrosoftPayments.prototype._loadProducts = function (callback) {
    if (connector.platform.oneOf(connector.G5WINDOWS) && this.connectedTime + 5000 > Date.now()) {
        setTimeout(() => this._loadProducts(callback), this.connectedTime + 5000 - Date.now());
        return;
    }

    const productIds = this.listProductIdsOfType(["consumable", "nonConsumable"]);
    
    connector.platform.callNative("store.loadProducts", { productIds }, (code, response) => {
        console.log(`MicrosoftPayments.loadProducts - ${JSON.stringify(response)}`);

        if (response.error || code !== connector.CODE_SUCCEED) {
            callback(connector.CODE_FAILED);
            console.log("Error requesting microsoft products", response.error);
            return;
        }

        const loadedProducts = response.products;
        const loadedIds = [];
        let unpriced = false;
        let currency;

        productIds.forEach((productId) => {
            const msProduct = loadedProducts[productId];

            if (!msProduct) {
                return;
            }

            const ourProduct = this.getProduct(productId);

            if (connector.platform.oneOf(connector.G5WINDOWS) && !msProduct.price) {
                if (ourProduct.priceLoaded) {
                    loadedIds.push(productId);
                } else {
                    ourProduct.textPrice = "...";
                    unpriced = true;
                }
                return;
            }

            loadedIds.push(productId);

            console.log(`MicrosoftPayments product ${ourProduct.itemId} ${ourProduct.productId} ${msProduct.price}`);

            const price = msProduct.price || "";

            const match = price.match(/[0-9.,]+/g);
            if (match && match[0]) {
                ourProduct.price = parseFloat(match[0].replace(",", "."));
                ourProduct.currency = msProduct.currencyCode;
                ourProduct.textPrice = msProduct.price;
                ourProduct.priceLoaded = true;

                currency = currency || msProduct.currencyCode;
            } else {
                this.bus.trigger("stream:console", `Error parsing microsoft product price ${price} ${JSON.stringify(msProduct)}`);
            }
        });

        if (currency) {
            this.currency = currency;
        }

        if (unpriced && (this.unpricedLoadAttempt || 0) < MicrosoftPayments.UNPRICED_LOAD_ATTEMPTS) {
            this.unpricedLoadAttempt = (this.unpricedLoadAttempt || 0) + 1;
            callback(connector.CODE_FAILED);
            return;
        }

        callback(connector.CODE_SUCCEED, loadedIds);
    });
};

MicrosoftPayments.prototype.purchase = function (product, callback) {
    connector.platform.callNative("store.purchase", {
        productId: product.productId
    }, (code, data) => {
        if (data.canceled) {
            console.log("MicrosoftPayments.onPurchaseCancelled", product.itemId);

            callback(ERRORS.PURCHASE.CANCEL, undefined, { message: data.canceled });
        } else if (data.error || code !== connector.CODE_SUCCEED) {
            console.log("MicrosoftPayments.onPurchaseFailure", product.itemId, data.error);

            this.bus.trigger("stream:error", `MicrosoftPayments.purchase productId:${product.productId} ${JSON.stringify(data.error)}`);

            callback(ERRORS.PURCHASE.UNKNOWN, undefined, { message: data.error });
        } else {
            console.log("MicrosoftPayments.onPurchaseSuccess", product.itemId, data);

            const purchase = this.createPurchase(data.paymentId, product);

            callback(connector.CODE_SUCCEED, purchase);
        }
    });
};

MicrosoftPayments.prototype.restore = function (callback) {
    connector.platform.callNative(
        "store.restore", 
        {},
        (code, data) => {
            const productId = data.productId;
            const paymentId = data.paymentId;

            if (!productId) {
                callback(connector.CODE_FAILED);
                return;
            }

            const product = this.getProduct(productId);
            if (!product) {
                console.log(`[connector] Restore product not found productId:${productId}`);

                this.consume({
                    paymentId,
                    productId
                }, () => {});

                callback(connector.CODE_FAILED);
                return;
            }

            const purchase = this.createPurchase(paymentId, product);

            callback(connector.CODE_SUCCEED, purchase);
        }
    );
};

MicrosoftPayments.prototype.isPaymentIdStable = function () {
    return !connector.platform.oneOf(connector.MICROSOFT);
};

MicrosoftPayments.prototype.consume = function (purchase, callback) {
    connector.platform.callNative("store.consume", {
        paymentId: purchase.paymentId,
        productId: purchase.productId
    }, (code, data) => {
        if (data.error) {
            this.bus.trigger("stream:error", `MicrosoftPayments.consume productId:${purchase.productId} ${JSON.stringify(data.error)}`);

            callback(connector.CODE_FAILED);
        } else {
            callback(connector.CODE_SUCCEED);
        }
    });
};

MicrosoftPayments.UNPRICED_LOAD_ATTEMPTS = 10;

MicrosoftPayments.prototype.canDeliverLate = function () {
    return true;
};

MicrosoftPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.MICROSOFT, connector.G5WINDOWS);
};
